import { render, staticRenderFns } from "./offer_2020.vue?vue&type=template&id=1a1248cf&scoped=true&"
import script from "./offer_2020.vue?vue&type=script&lang=js&"
export * from "./offer_2020.vue?vue&type=script&lang=js&"
import style0 from "./offer_2020.vue?vue&type=style&index=0&id=1a1248cf&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a1248cf",
  null
  
)

export default component.exports